import type { ChangeEvent } from 'react'
import React from 'react'

import { Select as SelectInput, withFormikSupport } from '@fourthwall/components'

import type { Props } from './types'

const SelectComponent = ({ data, value, name, onChange, onBlur, onSettingUpdate }: Props) => {
  const { id, label, options } = data

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(e)
    }

    onSettingUpdate(id, e.target.value)
  }

  return (
    <SelectInput
      label={label}
      name={name}
      value={value || ''}
      options={options}
      onChange={handleChange}
      onBlur={onBlur}
    />
  )
}

export const Select = withFormikSupport(SelectComponent)
